// gform.initializeOnLoaded(function () {
//   jQuery(document).on(
//     'gform_post_conditional_logic',
//     function (formId, fields, isInit) {
//       if (isInit) {
//         console.log('gform_post_conditional_logic running');
//       } else {
//         console.log('gform_post_conditional_logic  not running');
//       }
//     }
//   );
// });

jQuery(document).ready(function ($) {
  //Element animations
  $('.c-flip-card__item').on('inview', function (event, visible) {
    if (visible == true) {
      $(this).addClass('appearing');
      $('.c-flip-card__item')
        .not('.c-flip-card__item.on-hold')
        .removeClass('flipped');
      $('.c-flip-card__overlay')
        .not('.c-flip-card__overlay.on-hold')
        .removeClass('fade-in')
        .addClass('fade-out');
      // this = $(this);
      //console.log('In view!!!!');
    } else {
      //console.log('Not in view!!!');
      //$(this).removeClass('appearing');
    }
  });

  //Outline Plan Form
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    dataFormId = $('.c-form--outline-study-plan').attr('data-form-id');
    if (formId == dataFormId) {
      $('.c-form--outline-study-plan h2').hide();
      $(
        '.c-flip-card__item.appearing.flipped,  .c-flip-card__overlay.fade-in'
      ).addClass('on-hold');
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $('.c-form--outline-study-plan').offset().top - 300,
        },
        1000
      );
    }
  });

  const mqSM = window.matchMedia('(max-width: 767px)');
  const mqMD = window.matchMedia('(min-width: 768px)');
  if (mqSM.matches) {
    $('.c-flip-card__card.front,  .c-flip-card__flip-click--study').on(
      'click',
      function () {
        //Get modal id
        var modalDataId = $(this).attr('data-modal-id');
        //console.log('modal id: ' + modalDataId);
        //Add modalDataId to Modal
        $('.c-modal__container')
          .attr('data-modal-id', modalDataId)
          .children('.c-modal')
          .removeClass('is-closed', 'out');
        // if (
        //   typeof $('.c-modal__container').is(
        //     '[data-modal-id~="' + modalDataId + '"]'
        //   )
        // ) {
        // }
        $(this)
          .siblings('.c-flip-card__card.back')
          .addClass('in-modal')
          .appendTo($('.c-modal__inner'));
      }
    );

    // Close modal
    $('.c-modal__close').on('click', function () {
      var modalDataId = $(this).parent().parent().attr('data-modal-id');

      var cardBack = $(
        '.c-flip-card__card.front[data-modal-id="' + modalDataId + '"]'
      ).addClass('magic!');
      //console.log('pump ' + modalDataId);
      // console.log('Wee ' + cardBack);
      $(
        '.c-flip-card__card.front[data-modal-id="' + modalDataId + '"]'
      ).addClass('magic!');
      $('#modal_study .c-modal__inner > div').insertAfter(cardBack);
      $('.c-modal__container').removeAttr('data-modal-id');
      $('.c-flip-card__card.back').removeClass('in-modal');
      $('.c-flip-card__card-wrapper').removeClass('flipped');
      $('.c-modal__container')
        .children('.c-modal')
        .addClass('is-closed', 'out');
    });

    $('.c-flip-card__card').on('click', function () {
      $(this).parent().toggleClass('flipped');
    });
  } else if (mqMD.matches) {
    //Front Card Click
    $('.c-flip-card__card.front').on('click', function () {
      $('.c-flip-card__overlay').removeClass('fade-in, fade-out');
      $(this)
        .parent()
        .parent()
        .siblings('.c-flip-card__overlay')
        .addClass('fade-in');
      $(this).parent().parent().addClass('flipped');
      if ($(this).hasClass('card-form')) {
        $('.c-flip-card__overlay').addClass('on-hold');
        $('.c-flip-card__item.appearing.flipped').addClass('on-hold');
      }
    });

    function closeCard(overlayEl, itemEl) {
      var overlay = $(overlayEl);
      var item = $(itemEl);
      overlay
        .siblings('.c-flip-card__overlay')
        .removeClass('fade-in')
        .addClass('fade-out');
      item.removeClass('flipped');
      $('.c-flip-card__overlay').removeClass('on-hold');
      $('.c-flip-card__item').removeClass('on-hold');
    }

    //Back Card click
    $('.c-flip-card__card.back')
      .not('.c-flip-card__card-form')
      .on('click', function () {
        overlay = $(this).parent().parent();
        flipped = $(this).parent().parent();
        closeCard(overlay, flipped);
      });

    //Back Card Close button
    $('.c-flip-card__flip-click').on('click', function () {
      overlay = $('.c-flip-card__item');
      flipped = $('.c-flip-card__item');
      closeCard(overlay, flipped);
    });

    //Overlay click
    $('.c-flip-card__overlay').on('click', function () {
      $(this).removeClass('fade-in');
      $(this).addClass('fade-out');
      $('.c-flip-card__item').removeClass('flipped');
      $('.c-flip-card__overlay').removeClass('on-hold');
      $('.c-flip-card__item').removeClass('on-hold');
    });
  }
});
